import { render, staticRenderFns } from "./AdditionalField.vue?vue&type=template&id=151eb2ba&"
import script from "./AdditionalField.vue?vue&type=script&lang=js&"
export * from "./AdditionalField.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports